export default __webpack_public_path__ + "static/media/6 - Tim-Katz.d36514cf.jpg";